import { renderToString } from 'react-dom/server';
import { ProfileWithDetailsForAdmin, UserMessage } from '../../../../common/Types';
import { jsPDF } from 'jspdf';
import marked from 'marked';
import styled from 'styled-components';
import { FC } from 'react';
import { getRatingLabel } from './Utils';

const { parse: parseMarkdown } = marked;

const InterviewTranscriptBase = styled.div.attrs<{
  'data-theme'?: 'light' | 'dark';
}>({
  'data-theme': 'light',
})`
  display: flex;
  flex-direction: column;
  font-family: sans-serif;
  color: black;
`;
const HeaderBase = styled.header`
  margin-bottom: 2em;
`;
const HeaderTitle = styled.h2``;
const HeaderSectionLabel = styled.strong``;
const HeaderSection = styled.div``;
const MessageBase = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1em;
`;
const MessageTitle = styled.strong``;
const MessageContent = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1em;
  flex-wrap: wrap;
`;

type HeaderProps = {
  givenName?: string;
  familyName?: string;
  city?: string;
  state?: string;
  email?: string;
  phoneNumber?: string;
  linkedInUrl?: string;
  rating: number;
};

const Header: FC<HeaderProps> = ({
  givenName = '',
  familyName = '',
  city = '',
  state = '',
  email = '',
  phoneNumber = '',
  linkedInUrl = '',
  rating = 0,
}) => (
  <HeaderBase>
    <HeaderTitle>
      {givenName} {familyName}
    </HeaderTitle>
    <HeaderSection>
      <HeaderSectionLabel>City:</HeaderSectionLabel>
      &nbsp;
      <span>{city}</span>
    </HeaderSection>
    <HeaderSection>
      <HeaderSectionLabel>State:</HeaderSectionLabel>
      &nbsp;
      <span>{state}</span>
    </HeaderSection>
    <HeaderSection>
      <HeaderSectionLabel>Email:</HeaderSectionLabel>
      &nbsp;
      <a href={`mailto:${email}`} target="_blank" rel="noreferrer">
        {email}
      </a>
    </HeaderSection>
    <HeaderSection>
      <HeaderSectionLabel>Phone:</HeaderSectionLabel>
      &nbsp;
      <a href={`tel:${phoneNumber}`} target="_blank" rel="noreferrer">
        {phoneNumber}
      </a>
    </HeaderSection>
    <HeaderSection>
      <HeaderSectionLabel>LinkedIn:</HeaderSectionLabel>
      &nbsp;
      <a href={linkedInUrl} target="_blank" rel="noreferrer">
        {linkedInUrl}
      </a>
    </HeaderSection>
    <HeaderSection>
      <HeaderSectionLabel>Standing:</HeaderSectionLabel>
      &nbsp;
      <span>{getRatingLabel(rating)}</span>
    </HeaderSection>
  </HeaderBase>
);

const Message: FC<UserMessage> = ({ role = 'assistant', content = '' }) => (
  <MessageBase>
    <MessageTitle>{role === 'assistant' ? 'Interviewer:' : 'Candidate:'}</MessageTitle>
    <MessageContent
      dangerouslySetInnerHTML={{
        __html: parseMarkdown(content) as string,
      }}
    ></MessageContent>
  </MessageBase>
);

export const downloadInterviewTranscript = (
  // Transcript info.
  profile: ProfileWithDetailsForAdmin,
  ratting: number,
  interviewTranscript: UserMessage[] = []
) => {
  const { linkedInUrl, city, state, firstName, lastName, email, phoneNumber } = profile;
  const iTMarkup = (
    <InterviewTranscriptBase>
      <Header
        givenName={firstName}
        familyName={lastName}
        city={city}
        state={state}
        email={email}
        phoneNumber={phoneNumber}
        linkedInUrl={linkedInUrl}
        rating={ratting}
      />
      <br />
      {interviewTranscript.map((userMessage) => (
        <Message {...userMessage} />
      ))}
    </InterviewTranscriptBase>
  );
  const iTString = renderToString(iTMarkup);
  const pdf = new jsPDF();

  pdf.setTextColor(0, 0, 0);

  pdf.html(iTString, {
    autoPaging: 'text',
    windowWidth: 1024,
    width: 180,
    margin: 10,
    html2canvas: {
      backgroundColor: '#ffffff',
    },
    callback: () => pdf.save(`${firstName}${lastName}-Transcript.pdf`),
  });
};
